export const CBStructureFilterOptions = [
  {
    title: "Number of Institutions, Branches & Total Offices",
    fields: [
      { label: "Total Commercial Banks (Total Insured)", value: "TOTAL" },
      { label: "Total Branches", value: "BRANCHES" },
      { label: "Offices", value: "OFFICES" },
      { label: "Unit Banks", value: "UNIT" },
      { label: "Banks with Branches", value: "BRANCHIN" },
    ],
  },
  {
    title: "Changes in Number of Institutions",
    fields: [
      { label: "New Charters", value: "New_Char" },
      { label: "Conversions", value: "REL_CO" },
      { label: "Unassisted Mergers", value: "UNASSIST" },
      { label: "Failures: Assisted Merger", value: "MERGERS" },
      { label: "Failures: Paid Off", value: "PAID_OFF" },
      { label: "Other", value: "OTHER" },
      { label: "Total Commercial Banks (Total Insured)", value: "TOTAL" },
    ],
  },
];

export const CBFinancialFilterOptions = [
  {
    title: "Net Income",
    fields: [
      { label: "Total Commercial Banks (Filing Y/E Call)", value: "BANKS" },
      { label: "Total Interest Income", value: "INTINC", thousandsUS: true },
      { label: "Total Interest Expense", value: "EINTEXP", thousandsUS: true },
      { label: "Net Interest Income", value: "NIM", thousandsUS: true },
      { label: "Total Non-interest Income", value: "NONII", thousandsUS: true },
      {
        label: "Total Non-interest Expense",
        value: "NONIX",
        thousandsUS: true,
      },
      {
        label: "Provision for Loan & Lease Losses",
        value: "ELNATR",
        thousandsUS: true,
      },
      {
        label: "Pre-Tax Net Operating Income",
        value: "ITAXR",
        thousandsUS: true,
      },
      {
        label: "Securities Gains and Losses",
        value: "IGLSEC",
        thousandsUS: true,
      },
      { label: "Applicable Income Taxes", value: "ITAX", thousandsUS: true },
      { label: "Net Extraordinary Items", value: "EXTRA", thousandsUS: true },
      {
        label: "Net Income Attributable to Noncontrolling Interests",
        value: "NETIMIN",
        thousandsUS: true,
      },
      { label: "Net Income", value: "NETINC", thousandsUS: true },
    ],
  },
  {
    title: "Interest Income (Int Inc)",
    fields: [
      {
        label: "Int Inc - Domestic Office Loans",
        value: "ILNDOM",
        thousandsUS: true,
      },
      {
        label: "Int Inc - Foreign Office Loans",
        value: "ILNFOR",
        thousandsUS: true,
      },
      { label: "Int Inc - Leases", value: "ILS", thousandsUS: true },
      {
        label: "Int Inc - Total Loans & Leases",
        value: "ILNLS",
        thousandsUS: true,
      },
      {
        label: "Int Inc - Investment Securities",
        value: "ISC",
        thousandsUS: true,
      },
      {
        label: "Int Inc - Trading Account Assets",
        value: "ITRADE",
        thousandsUS: true,
      },
      {
        label: "Int Inc - Fed Funds Sold git Securities Purchased",
        value: "IFREPO",
        thousandsUS: true,
      },
      { label: "Int Inc - Balances Due", value: "ICHBAL", thousandsUS: true },
      { label: "Int Inc - Total Other", value: "TINTINC", thousandsUS: true },
      { label: "Total Interest Income", value: "INTINC", thousandsUS: true },
    ],
  },
  {
    title: "Interest Expense (Int Exp)",
    fields: [
      {
        label: "Int Exp - Deposit in Domestic Offices",
        value: "EDEPDOM",
        thousandsUS: true,
      },
      {
        label: "Int Exp - Deposits in Foreign Offices",
        value: "EDEPFOR",
        thousandsUS: true,
      },
      {
        label: "Int Exp - Total Deposits (Dom and For)",
        value: "EDEP",
        thousandsUS: true,
      },
      {
        label: "Int Exp - Fed Funds Purchased/Securities Sold",
        value: "EFREPP",
        thousandsUS: true,
      },
      { label: "Int Exp - Borrowed Money", value: "NEW6_1", thousandsUS: true },
      {
        label: "Int Exp - Subordinated Notes",
        value: "ESUBND",
        thousandsUS: true,
      },
      {
        label: "Int Exp - Total Deposits (Other)",
        value: "TOINTEXP",
        thousandsUS: true,
      },
      { label: "Total Interest Expense", value: "EINTEXP", thousandsUS: true },
    ],
  },
  {
    title: "Non-interest Income/Expense",
    fields: [
      {
        label: "Service Charges on Deposit Accounts",
        value: "ISERCHG",
        thousandsUS: true,
      },
      {
        label: "Other Non-interest Income",
        value: "OONONII",
        thousandsUS: true,
      },
      { label: "Total Non-interest Income", value: "NONII", thousandsUS: true },
      {
        label: "Employee Salaries and Benefits",
        value: "ESAL",
        thousandsUS: true,
      },
      { label: "Occupancy Expense", value: "EPREMAGG", thousandsUS: true },
      {
        label: "All Other Non-interest Expenses",
        value: "EOTHNINT",
        thousandsUS: true,
      },
      {
        label: "Total Non-interest Expense",
        value: "NONIX",
        thousandsUS: true,
      },
      {
        label: "Number of Full Time Employees",
        value: "NUMEMP",
        thousandsUS: true,
      },
    ],
  },
  {
    title: "Charge-offs, Recoveries, & Dividends",
    fields: [
      { label: "Loan & Lease Charge-offs", value: "DRLNLS" },
      { label: "Loan & Lease Recoveries", value: "CRLNLS", thousandsUS: true },
      {
        label: "Net Loan & Lease Charge-offs",
        value: "NTLNLS",
        thousandsUS: true,
      },
      {
        label: "Cash Dividends Declared (Preferred)",
        value: "EQCDIVP",
        thousandsUS: true,
      },
      {
        label: "Cash Dividends Declared (Common)",
        value: "EQCDIVC",
        thousandsUS: true,
      },
      {
        label: "Total Cash Dividends Declared",
        value: "EQCDIV",
        thousandsUS: true,
      },
    ],
  },
  {
    title: "Assets",
    fields: [
      { label: "Total Commercial Banks (Filing Y/E Call)", value: "BANKS" },
      {
        label: "Cash & Due from Depository Institutions",
        value: "CHBAL",
        thousandsUS: true,
      },
      {
        label: "Total Investment Securities (Book Value)",
        value: "SC",
        thousandsUS: true,
      },
      { label: "Total Loans and Leases", value: "LNLSGR", thousandsUS: true },
      {
        label: "Allowance for Losses Loans and Leases",
        value: "LNATRES",
        thousandsUS: true,
      },
      { label: "Net Loans and Leases", value: "LNLSNET", thousandsUS: true },
      { label: "Other Earning Assests", value: "OEA", thousandsUS: true },
      { label: "Bank Premises and Equipment", value: "BKPREM" },
      { label: "Other Real Estate Owned", value: "ORE", thousandsUS: true },
      { label: "Intangible Assets", value: "INTAN", thousandsUS: true },
      { label: "All Other Assets", value: "NEW9_1", thousandsUS: true },
      { label: "Total Assets", value: "ASSET", thousandsUS: true },
    ],
  },
  {
    title: "Investment Securities",
    fields: [
      { label: "U.S. Treasury Securities", value: "SCUST", thousandsUS: true },
      {
        label: "U.S. Agencies and Corporation Securities",
        value: "SCAGE",
        thousandsUS: true,
      },
      {
        label: "States and Political Subdivisions Securities",
        value: "SCMUNI",
        thousandsUS: true,
      },
      { label: "Corporate Bonds and Other Securities", value: "NEW10_1" },
      { label: "Equity Securities", value: "SCEQ", thousandsUS: true },
      {
        label: "Total Investment Securities (Book Value)",
        value: "SC",
        thousandsUS: true,
      },
      { label: "Market Values", value: "SCMV", thousandsUS: true },
      { label: "Trading Account Securities", value: "NEW10_2" },
      {
        label: "Memo: Valuation Reserves",
        value: "NEW10_3",
        thousandsUS: true,
      },
    ],
  },
  {
    title: "Loans and Leases",
    fields: [
      { label: "Total Real Estate Loans", value: "LNRE", thousandsUS: true },
      {
        label: "Loans to Deposit Institutions",
        value: "LNDEP",
        thousandsUS: true,
      },
      { label: "Agricultural Loans", value: "LNAG", thousandsUS: true },
      {
        label: "Commercial and Industrial Loans",
        value: "LNCI",
        thousandsUS: true,
      },
      {
        label: "Total Loans to Individuals",
        value: "LNCON",
        thousandsUS: true,
      },
      {
        label: "Loans to States and Politicial Sub-divisions",
        value: "LNMUNI",
        thousandsUS: true,
      },
      { label: "All Other Loans", value: "NEW11_1", thousandsUS: true },
      { label: "Leases", value: "LS", thousandsUS: true },
      { label: "Gross Loans and Leases", value: "LNLS", thousandsUS: true },
      { label: "Unearned Income", value: "UNINC", thousandsUS: true },
      {
        label: "Allowance for Losses Loans and Leases",
        value: "LNATRES",
        thousandsUS: true,
      },
      { label: "Net Loans and Leases", value: "LNLSNET", thousandsUS: true },
      { label: "Total Loans and Leases", value: "LNLSGR", thousandsUS: true },
    ],
  },
  {
    title: "Real Estate Loans (R/E)",
    fields: [
      {
        label: "R/E Loan - Construction & Land Develop",
        value: "LNRECONS",
        thousandsUS: true,
      },
      { label: "R/E Loan - 1-4 Family", value: "LNRERES", thousandsUS: true },
      {
        label: "R/E Loans - Multifamily",
        value: "LNREMULT",
        thousandsUS: true,
      },
      { label: "R/E Loan - Farmland", value: "LNREAG", thousandsUS: true },
      {
        label: "R/E Loan - Non-farm/Non-residential Prop",
        value: "LNRENRES",
        thousandsUS: true,
      },
      {
        label: "Total R/E Loans in Domestic Offices",
        value: "LNREDOM",
        thousandsUS: true,
      },
      {
        label: "Total R/E Loans in Foreign Offices",
        value: "LNREFOR",
        thousandsUS: true,
      },
      { label: "Total Real Estate Loans", value: "LNRE", thousandsUS: true },
    ],
  },
  {
    title: "Loans to Individuals",
    fields: [
      {
        label: "Loans to Individuals - Credit Card Plans",
        value: "LNCRCD",
        thousandsUS: true,
      },
      {
        label: "Loans to Individuals - All Others",
        value: "LNCONOTH",
        thousandsUS: true,
      },
      {
        label: "Memo: Loans to Individuals - Auto",
        value: "LNAUTO",
        thousandsUS: true,
      },
      {
        label: "Memo: Loans to Individuals - Mobile Homes",
        value: "LNMOBILE",
        thousandsUS: true,
      },
      {
        label: "Memo: Loans to Individuals - Single Payment",
        value: "LNSP",
        thousandsUS: true,
      },
      {
        label: "Total Loans to Individuals",
        value: "LNCON",
        thousandsUS: true,
      },
    ],
  },
  {
    title: "Liabilities and Equity Capital",
    fields: [
      { label: "Total Commercial Banks (Filing Y/E Call)", value: "BANKS" },
      { label: "Total Deposits", value: "DEP", thousandsUS: true },
      { label: "Borrowed Funds", value: "NEW14_1", thousandsUS: true },
      {
        label: "Subordinated Notes/Debentures",
        value: "SUBND",
        thousandsUS: true,
      },
      { label: "Other Liabilities", value: "NEW14_2", thousandsUS: true },
      { label: "Total Liabilities", value: "NEW14_3", thousandsUS: true },
      { label: "Perpetual Preferred Stock", value: "EQPP", thousandsUS: true },
      { label: "Common Stock", value: "EQCS", thousandsUS: true },
      { label: "Surplus", value: "EQSUR", thousandsUS: true },
      { label: "Undivided Profits", value: "NEW14_4", thousandsUS: true },
      { label: "Other Capital", value: "EQOTHCC" },
      { label: "Total Equity Capital", value: "EQNM", thousandsUS: true },
    ],
  },
  {
    title: "Deposits",
    fields: [
      {
        label: "Deposits - Individuals, Partnerships and Corporations",
        value: "NEW15_1",
        thousandsUS: true,
      },
      {
        label: "Deposits - U.S. Government",
        value: "NEW15_2",
        thousandsUS: true,
      },
      {
        label: "Deposits - States and Political Subdivisions",
        value: "NEW15_3",
        thousandsUS: true,
      },
      { label: "Deposits - All Other", value: "NEW15_4", thousandsUS: true },
      { label: "Total Deposits", value: "DEP", thousandsUS: true },
      { label: "Interest Bearing Deposits", value: "DEPI", thousandsUS: true },
      {
        label: "Memo: Deposits - Non-interest Bearing",
        value: "DEPNI",
        thousandsUS: true,
      },
      { label: "Deposits - Domestic Demand", value: "DDT", thousandsUS: true },
      {
        label: "Deposits - Domestic Savings",
        value: "NEW15_5",
        thousandsUS: true,
      },
      {
        label: "Deposits - Domestic Time",
        value: "NTRTIME",
        thousandsUS: true,
      },
      { label: "Total Domestic Deposits", value: "NEW15_7", thousandsUS: true },
      {
        label: "Memo: Domestic Deposits Transaction",
        value: "TRN",
        thousandsUS: true,
      },
      {
        label: "Memo: Domestic Deposits Non-Transaction",
        value: "NTR",
        thousandsUS: true,
      },
      {
        label: "Foreign Deposits - Non-interest Bearing",
        value: "DEPNIFOR",
        thousandsUS: true,
      },
      {
        label: "Foreign Deposits - Interest Bearing",
        value: "DEPIFOR",
        thousandsUS: true,
      },
      { label: "Total Foreign Deposits", value: "DEPFOR", thousandsUS: true },
    ],
  },
  {
    title: "Interest Earning Asset and Interest Bearing Liabilities",
    fields: [
      {
        label: "Interest Earning Balances",
        value: "CHBALI",
        thousandsUS: true,
      },
      {
        label: "Total Investment Securities (Book Value)",
        value: "SC",
        thousandsUS: true,
      },
      { label: "Net Loans and Leases", value: "LNLSNET", thousandsUS: true },
      { label: "Federal Funds Sold", value: "FREPO", thousandsUS: true },
      { label: "Trading Account Assets", value: "TRADE", thousandsUS: true },
      {
        label: "Total Interest Earning Assets",
        value: "INTBAST",
        thousandsUS: true,
      },
      { label: "Interest Bearing Deposits", value: "DEPI", thousandsUS: true },
      {
        label: "Fed Funds & Repos Purchased",
        value: "FREPP",
        thousandsUS: true,
      },
      {
        label: "Mortgage and Other Borrowings",
        value: "MTGLS",
        thousandsUS: true,
      },
      {
        label: "Demand Notes and Other Liabilities",
        value: "NEW16_1",
        thousandsUS: true,
      },
      {
        label: "Subordinated Notes/Debentures",
        value: "SUBND",
        thousandsUS: true,
      },
      {
        label: "Total Interest Bearing Liabilities",
        value: "INTBLIB",
        thousandsUS: true,
      },
    ],
  },
  {
    title: "Past Due (P/D) & Non-accrual Loans & Leases",
    fields: [
      {
        label: "Loans & Leases P/D 30-89 Days",
        value: "P3LNLS",
        thousandsUS: true,
      },
      {
        label: "Loans & Leases P/D 90+ Days",
        value: "P9LNLS",
        thousandsUS: true,
      },
      {
        label: "Total Loans and Leases Past Due",
        value: "TPD",
        thousandsUS: true,
      },
      {
        label: "Non-accrual Loans & Leases",
        value: "NALNLS",
        thousandsUS: true,
      },
      {
        label: "Total Non-current Loans & Leases",
        value: "NCLNLS",
        thousandsUS: true,
      },
    ],
  },
];

export const SIStructureFilterOptions = [
  {
    title:
      "Number of Institutions by Regulatory Agent and Insurance Fund (National Only)",
    fields: [
      {
        label: "Total Savings Institutions (Total Insured)",
        value: "SAVINGS",
        specialNote: true,
      },
      { label: "Total Branches", value: "BRANCHES" },
      { label: "FDIC supervised, SAIF Insured Institutions", value: "FD_SAIF" },
      { label: "FDIC Supervised, BIF Insured Institutions", value: "FD_BIF" },
      {
        label: "Total FDIC Supervised Savings Institutions",
        value: "TOT_FDIC",
      },
      {
        label: "Non FDIC Supervised SAIF Insured Institutions",
        value: "OT_SAIF",
      },
      {
        label: "Non FDIC Supervised BIF Insured Institutions",
        value: "OT_BIF",
      },
      {
        label: "Total Non FDIC Supervised Savings Institutions",
        value: "TOT_OTS",
      },
      { label: "RTC Conservatorships", value: "CONS" },
    ],
  },
  {
    title: "Changes in Number of Institutions(National Only)",
    fields: [
      { label: "New Charters", value: "newcount" },
      { label: "New Charters to Absorb Another Charter", value: "alsonew" },
      { label: "Non-insured Becoming insured", value: "chrtrest" },
      { label: "Charter Transfers from Commercial Banks", value: "chartoth" },
      {
        label: "Unassisted Mergers/Consolidations of Thrifts",
        value: "combos",
      },
      { label: "Unassisted Mergers with Commercial Banks", value: "tomerg" },
      { label: "Assisted Mergers with Thrifts", value: "comboass" },
      { label: "Assisted Mergers with Commercial Banks", value: "tofail" },
      { label: "Assisted Payouts", value: "LIQASSTD" },
      { label: "Failures Transferred to the RTC", value: "tortc" },
      { label: "Voluntary Liquidations", value: "LIQUNASS" },
      { label: "Charter Transfers to Commercial Banks", value: "tochrt" },
      { label: "Other Misc. Adjustments", value: "MISSADJ" },
    ],
  },
];

export const SIFinancialFilterOptions = [
  {
    title: "Net Income",
    fields: [
      { label: "Total Savings Institutions (Filing Y/E Call)", value: "COUNT" },
      { label: "Total Interest Income", value: "INTINC", thousandsUS: true },
      { label: "Total Interest Expense", value: "EINTEXP", thousandsUS: true },
      { label: "Net Interest Income", value: "NIM", thousandsUS: true },
      { label: "Total Non-interest Income", value: "NONII", thousandsUS: true },
      {
        label: "Total Non-interest Expense",
        value: "NONIX",
        thousandsUS: true,
      },
      {
        label: "Provision for Loan & Lease Losses",
        value: "ELNATR",
        thousandsUS: true,
      },
      {
        label: "Pre-Tax Net Operating Income",
        value: "PTXNOINC",
        thousandsUS: true,
      },
      {
        label: "Securities Gains and Losses",
        value: "IGLSEC",
        thousandsUS: true,
      },
      { label: "Applicable Income Taxes", value: "ITAX", thousandsUS: true },
      { label: "Net Extraordinary Items", value: "EXTRA", thousandsUS: true },
      { label: "Net Income", value: "NETINC", thousandsUS: true },
    ],
  },
  {
    title: "Interest Income (Int Inc)",
    fields: [
      { label: "Int Inc - Loans", value: "ILNS", thousandsUS: true },
      { label: "Int Inc - Leases", value: "ILS", thousandsUS: true },
      {
        label: "Int Inc - Total Loans & Leases",
        value: "ILNLS",
        thousandsUS: true,
      },
      { label: "Int Inc - Investment Securities", value: "ISC" },
      {
        label: "Int Inc - Trading Account Assets",
        value: "ITRADE",
        thousandsUS: true,
      },
      {
        label: "Int Inc - Fed Funds Sold/Securities Purchased",
        value: "IFREPO",
        thousandsUS: true,
      },
      { label: "Int Inc - Balances Due", value: "ICHBAL", thousandsUS: true },
      { label: "Int Inc - Total Other", value: "TINTINC", thousandsUS: true },
      { label: "Total Interest Income", value: "INTINC", thousandsUS: true },
    ],
  },
  {
    title: "Interest Expense (Int Exp)",
    fields: [
      {
        label: "Int Exp - Total Deposits (Dom and For)",
        value: "EDEP",
        thousandsUS: true,
      },
      {
        label: "Int Exp - Fed Funds Purchased/Securities Sold",
        value: "EFREPP",
      },
      {
        label: "Int Exp Oth - Borrowed Money",
        value: "OTHBORR",
        thousandsUS: true,
      },
      {
        label: "Int Exp - Subordinated Notes",
        value: "ESUBND",
        thousandsUS: true,
      },
      {
        label: "Int Exp Oth - Advances From FHLB",
        value: "EFHLBADV",
        thousandsUS: true,
      },
      {
        label: "Int Exp - Total Deposits (Other)",
        value: "TOINTEXP",
        thousandsUS: true,
      },
      { label: "Total Interest Expense", value: "EINTEXP", thousandsUS: true },
    ],
  },
  {
    title: "Non-interest Income/Expense",
    fields: [
      { label: "Fee Income", value: "IFEE", thousandsUS: true },
      {
        label: "Other Non-interest Income",
        value: "OONONII",
        thousandsUS: true,
      },
      { label: "Total Non-interest Income", value: "NONII", thousandsUS: true },
      {
        label: "Employee Salaries and Benefits",
        value: "ESAL",
        thousandsUS: true,
      },
      { label: "Occupancy Expense", value: "EPREMAGG", thousandsUS: true },
      {
        label: "All Other Non-interest Expenses",
        value: "EOTHNINT",
        thousandsUS: true,
      },
      {
        label: "Total Non-interest Expense",
        value: "NONIX",
        thousandsUS: true,
      },
      { label: "Memo: Amortization of Intangibles", value: "EAMINTAN" },
      {
        label: "Number of Full Time Employees",
        value: "NUMEMP",
        thousandsUS: true,
      },
    ],
  },
  {
    title: "Charge-offs, Recoveries, & Dividends",
    fields: [
      { label: "Loan & Lease Charge-offs", value: "DRLNLS", thousandsUS: true },
      { label: "Loan & Lease Recoveries", value: "CRLNLS", thousandsUS: true },
      {
        label: "Net Loans and Leases Charge-offs",
        value: "NCHGREC",
        thousandsUS: true,
      },
      {
        label: "Cash Dividends Declared (Preferred)",
        value: "EQCDIVP",
        thousandsUS: true,
      },
      {
        label: "Cash Dividends Declared (Common)",
        value: "EQCDIVC",
        thousandsUS: true,
      },
      {
        label: "Total Cash Dividends Declared",
        value: "EQCDIV",
        thousandsUS: true,
      },
    ],
  },
  {
    title: "Assets",
    fields: [
      { label: "Total Savings Institutions (Filing Y/E Call)", value: "COUNT" },
      {
        label: "Cash & Due from Depository Institutions",
        value: "CHBAL",
        thousandsUS: true,
      },
      {
        label: "Total Investment Securities (Book Value)",
        value: "SC",
        thousandsUS: true,
      },
      { label: "Total Loans and Leases", value: "LNLSGR", thousandsUS: true },
      {
        label: "Allowance for Losses Loans and Leases",
        value: "LNATRES",
        thousandsUS: true,
      },
      { label: "Net Loans and Leases", value: "LNLSNET", thousandsUS: true },
      { label: "Other Earning Assests", value: "OEA", thousandsUS: true },
      {
        label: "Bank Premises and Equipment",
        value: "BKPREM",
        thousandsUS: true,
      },
      { label: "Other Real Estate", value: "ORET", thousandsUS: true },
      { label: "Intangible Assets", value: "INTAN", thousandsUS: true },
      { label: "All Other Assets", value: "OTHASST", thousandsUS: true },
      { label: "Total Assets", value: "ASSET" },
    ],
  },
  {
    title: "Investment Securities",
    fields: [
      { label: "U.S. Treasury Securities", value: "SCUST", thousandsUS: true },
      {
        label: "U.S. Agencies and Corporation Securities",
        value: "SCAGE",
        thousandsUS: true,
      },
      { label: "U.S. Treasury & Agency", value: "SCUS", thousandsUS: true },
      {
        label: "States and Political Subdivisions Securities",
        value: "SCMUNI",
        thousandsUS: true,
      },
      { label: "Other Debt Securities", value: "CORPBNDS", thousandsUS: true },
      { label: "Equity Securities", value: "SCEQ", thousandsUS: true },
      { label: "Less: Contra Accounts", value: "SCRES", thousandsUS: true },
      { label: "Less: Trading Accounts", value: "TRADES", thousandsUS: true },
      {
        label: "Total Investment Securities (Book Value)",
        value: "SC",
        thousandsUS: true,
      },
      {
        label: "Memo: Mortgage Backed Securities",
        value: "SCMTGBK",
        thousandsUS: true,
      },
    ],
  },
  {
    title: "Loans and Leases",
    fields: [
      { label: "Total Real Estate Loans", value: "LNRE", thousandsUS: true },
      {
        label: "Loans to Deposit Institutions",
        value: "LNDEP",
        thousandsUS: true,
      },
      { label: "Agricultural Loans", value: "LNAG", thousandsUS: true },
      {
        label: "Commercial and Industrial Loans",
        value: "LNCI",
        thousandsUS: true,
      },
      {
        label: "Total Loans to Individuals",
        value: "LNCON",
        thousandsUS: true,
      },
      {
        label: "Loans to States and Politicial Sub-divisions",
        value: "LNMUNI",
        thousandsUS: true,
      },
      { label: "All Other Loans", value: "ALLOTHER", thousandsUS: true },
      { label: "Leases", value: "LS", thousandsUS: true },
      { label: "Unearned Income", value: "UNINC", thousandsUS: true },
      {
        label: "Less: Other Contra Accounts",
        value: "OTLNCNTA",
        thousandsUS: true,
      },
      { label: "Total Loans and Leases", value: "LNLSGR", thousandsUS: true },
      {
        label: "Allowance for Losses Loans and Leases",
        value: "LNATRES",
        thousandsUS: true,
      },
      { label: "Net Loans and Leases", value: "LNLSNET", thousandsUS: true },
    ],
  },
  {
    title: "Real Estate Loans (R/E)",
    fields: [
      {
        label: "R/E Loan - Construction & Land Develop",
        value: "LNRECONS",
        thousandsUS: true,
      },
      { label: "R/E Loan - 1-4 Family", value: "LNRERES", thousandsUS: true },
      {
        label: "R/E Loans - Multifamily",
        value: "LNREMULT",
        thousandsUS: true,
      },
      {
        label: "R/E Loan - Non-farm/Non-residential Prop",
        value: "LNRENRES",
        thousandsUS: true,
      },
      { label: "Total Real Estate Loans", value: "LNRE", thousandsUS: true },
      { label: "Memo: Home Equity Loans", value: "LNRELOC", thousandsUS: true },
      { label: "Memo: Contra Account", value: "LNRESRE", thousandsUS: true },
    ],
  },
  {
    title: "Loans to Individuals",
    fields: [
      {
        label: "Loans to Individuals - Credit Card Plans",
        value: "LNCRCD",
        thousandsUS: true,
      },
      {
        label: "Loans to Individuals - Home Improvement",
        value: "LNCONOT1",
        thousandsUS: true,
      },
      {
        label: "All Other Loans to Individuals",
        value: "LNALLOTH",
        thousandsUS: true,
      },
      {
        label: "Total Loans to Individuals",
        value: "LNCON",
        thousandsUS: true,
      },
    ],
  },
  {
    title: "Liabilities and Equity Capital",
    fields: [
      { label: "Total Savings Institutions (Filing Y/E Call)", value: "COUNT" },
      { label: "Total Deposits", value: "DEP", thousandsUS: true },
      { label: "Borrowed Funds", value: "OTHNBORR", thousandsUS: true },
      { label: "Subordinated Notes", value: "SUBLLPF", thousandsUS: true },
      { label: "Other Liabilities", value: "OTHLIAB", thousandsUS: true },
      { label: "Total Liabilities", value: "LIAB", thousandsUS: true },
      { label: "Perpetual Preferred Stock", value: "EQPP", thousandsUS: true },
      { label: "Common Stock", value: "EQCS", thousandsUS: true },
      { label: "Surplus", value: "EQSUR", thousandsUS: true },
      { label: "Undivided Profits", value: "EQUPTOT", thousandsUS: true },
      {
        label: "FDIC Net Worth Certificates",
        value: "EQNWCERT",
        thousandsUS: true,
      },
      { label: "Total Equity Capital", value: "EQNM", thousandsUS: true },
      {
        label: "Total Liabilities and Equity Capital",
        value: "LIABEQ",
        thousandsUS: true,
      },
    ],
  },
  {
    title: "Deposits",
    fields: [
      { label: "Total Deposits", value: "DEP", thousandsUS: true },
      { label: "Deposits - Domestic Demand", value: "DDT", thousandsUS: true },
      {
        label: "Memo: Time Deposits (Over $100K)",
        value: "NTRTMLG",
        thousandsUS: true,
      },
      {
        label: "Memo: IRA's and Keogh Plan-Deposits",
        value: "IRAKEOGH",
        thousandsUS: true,
      },
      { label: "Memo: Brokered Deposits", value: "BRO", thousandsUS: true },
    ],
  },
  {
    title: "Interest Earning Asset and Interest Bearing Liabilities",
    fields: [
      {
        label: "Interest Earning Balances",
        value: "CHBALI",
        thousandsUS: true,
      },
      {
        label: "Total Investment Securities (Book Value)",
        value: "SC",
        thousandsUS: true,
      },
      { label: "Net Loans and Leases", value: "LNLSNET", thousandsUS: true },
      { label: "Federal Funds Sold", value: "FREPO", thousandsUS: true },
      { label: "Trading Account Assets", value: "TRADE", thousandsUS: true },
      {
        label: "Total Interest Earning Assets",
        value: "INTBAST",
        thousandsUS: true,
      },
      { label: "Interest Bearing Deposits", value: "DEPI", thousandsUS: true },
      {
        label: "Fed Funds & Repos Purchased",
        value: "FREPP",
        thousandsUS: true,
      },
      { label: "Advances from FHLB", value: "OTHBFHLB", thousandsUS: true },
      {
        label: "Demand Notes and Other Borrowings",
        value: "OINTBOR",
        thousandsUS: true,
      },
      { label: "Subordinated Notes", value: "SUBLLPF", thousandsUS: true },
      {
        label: "FDIC Net Worth Certificates",
        value: "EQNWCERT",
        thousandsUS: true,
      },
      {
        label: "Total Interest Bearing Liabilities",
        value: "INTBLIB",
        thousandsUS: true,
      },
    ],
  },
  {
    title: "Past Due (P/D) & Non-accrual Loans & Leases",
    fields: [
      {
        label: "Loans & Leases P/D 30-89 Days",
        value: "P3LNLS",
        thousandsUS: true,
      },
      {
        label: "Loans & Leases P/D 90+ Days",
        value: "P9LNLS",
        thousandsUS: true,
      },
      {
        label: "Total Loans and Leases Past Due",
        value: "TPD",
        thousandsUS: true,
      },
      {
        label: "Non-accrual Loans & Leases",
        value: "NALNLS",
        thousandsUS: true,
      },
      {
        label: "Total Non-current Loans & Leases",
        value: "NCLNLS",
        thousandsUS: true,
      },
    ],
  },
];

export const DetailsFilterOptions = [
  { label: "FIN", value: "FIN" },
  { label: "Location", value: "CITYST" },
  { label: "Effective Date", value: "FAILDATE" },
  { label: "Insurance Fund", value: "SAVR" },
  { label: "Resolution", value: "RESTYPE" },
  { label: "Estimated Loss", value: "COST", thousandsUS: true },
  { label: "Transaction Type", value: "RESTYPE1" },
  { label: "Charter Class	", value: "CHCLASS1" },
  { label: "Total Deposits", value: "QBFDEP", thousandsUS: true },
  { label: "Total Asset", value: "QBFASSET", thousandsUS: true },
];

export const ByStateFilterOptions = [
  { label: "Resolution: FAILURE", value: "count_RESTYPE_FAILURE" },
  { label: "Resolution: ASSISTANCE", value: "count_RESTYPE_ASSISTANCE" },
  { label: "Total Assets", value: "sum_QBFASSET", thousandsUS: true },
  { label: "Total Deposits", value: "sum_QBFDEP", thousandsUS: true },
  { label: "Estimated Loss", value: "sum_COST", thousandsUS: true },
];

export const ByYearFilterOptions = [
  { label: "Resolution: FAILURE", value: "count_RESTYPE_FAILURE" },
  { label: "Resolution: ASSISTANCE", value: "count_RESTYPE_ASSISTANCE" },
  { label: "Insurance Fund: BIF", value: "count_SAVR_BIF" },
  { label: "Insurance Fund: RTC", value: "count_SAVR_RTC" },
  { label: "Insurance Fund: FSLIC", value: "count_SAVR_FSLIC" },
  { label: "Insurance Fund: SAIF", value: "count_SAVR_SAIF" },
  { label: "Insurance Fund: DIF", value: "count_SAVR_DIF" },
  { label: "Insurance Fund: FDIC", value: "count_SAVR_FDIC" },
  { label: "Charter Class: N", value: "count_CHCLASS1_N" },
  { label: "Charter Class: SM", value: "count_CHCLASS1_SM" },
  { label: "Charter Class: NM", value: "count_CHCLASS1_NM" },
  { label: "Charter Class: SA", value: "count_CHCLASS1_SA" },
  { label: "Charter Class: SB", value: "count_CHCLASS1_SB" },
  { label: "Transaction Type: A/A", value: "count_RESTYPE1_A/A" },
  { label: "Transaction Type: REP", value: "count_RESTYPE1_REP" },
  { label: "Transaction Type: P&A", value: "count_RESTYPE1_P&A" },
  { label: "Transaction Type: PA", value: "count_RESTYPE1_PA" },
  { label: "Transaction Type: PI", value: "count_RESTYPE1_PI" },
  { label: "Transaction Type: IDT", value: "count_RESTYPE1_IDT" },
  { label: "Transaction Type: MGR", value: "count_RESTYPE1_MGR" },
  { label: "Transaction Type: PO", value: "count_RESTYPE1_PO" },
];
